<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-transparent";
    export let hover = "group-hover:stroke-mblue group-hover:fill-mblue";
    export let strokeWidth = "1";
    export let classList = "aspect-ratio transition-all";
</script>

<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
    style="enable-background:new 0 0 24 24;"
>
<g>
	<path d="M22,12.8c-0.2,0-0.4-0.1-0.5-0.2l-5-5c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l5,5
		c0.3,0.3,0.3,0.8,0,1.1C22.4,12.7,22.2,12.7,22,12.8z"/>
	<path d="M17,12.8c-0.4,0-0.7-0.3-0.7-0.8c0-0.2,0.1-0.4,0.2-0.5l5-5c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1l-5,5
		C17.4,12.7,17.2,12.8,17,12.8z"/>
	<path d="M8.5,12h1c3.9,0,7,3.1,7,7c0,1.7-1.3,3-3,3h-9c-1.7,0-3-1.3-3-3C1.5,15.1,4.6,12,8.5,12z"/>
	<circle cx="9" cy="6.5" r="4.5"/>
</g>
</svg>
